"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateWorksScore = exports.updataReadTime = exports.setPrize = exports.scoreRule = exports.getWorksList = exports.getWorksById = exports.getRules = exports.getReadTimes = exports.getPhotoList = exports.getMatchesForWorks = exports.getCommit = exports.exitWorksStatus = exports.downFilesByWorkIds = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
var _qs = _interopRequireDefault(require("qs"));
/**
 * 描述 获取角色列表
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data 
 * @returns {any}
 */
var getMatchesForWorks = exports.getMatchesForWorks = function getMatchesForWorks(data) {
  return _api.default.request({
    url: '/matchWorks/getMatchesForWorks',
    method: 'post',
    data: data
  });
};
/**
 * 描述 获取文件快照
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data 
 * @returns {any}
 */
var getPhotoList = exports.getPhotoList = function getPhotoList(data) {
  return _api.default.request({
    url: '/uploadFile/getFileByUrl',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};

/**
 * 获取作品列表
 * @author whz
 * @date 2021-11-23
 * @param {any} data 
 * @returns {any}
 */
var getWorksList = exports.getWorksList = function getWorksList(data) {
  return _api.default.request({
    url: '/matchWorks/getWorksList',
    method: 'post',
    data: data
  });
};

/**
 * 设置奖项
 * @author whz
 * @date 2021-11-23
 * @param {any} data 
 * @returns {any}
 */
var setPrize = exports.setPrize = function setPrize(data) {
  return _api.default.request({
    url: '/matchWorks/setPrize',
    method: 'post',
    data: data
  });
};
var downFilesByWorkIds = exports.downFilesByWorkIds = function downFilesByWorkIds(data) {
  return _api.default.request({
    url: '/matchWorks/downFilesByWorkIds',
    method: 'post',
    data: data
  });
};

/**
 * 获取作品详情
 * @author whz
 * @date 2021-11-23
 * @param {any} data 
 * @returns {any}
 */
var getWorksById = exports.getWorksById = function getWorksById(data) {
  return _api.default.request({
    url: '/matchWorks/getWorksById',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
/**
 * 描述 获取作品对应的评分项
 * @author kkdy
 * @date 2021-12-06
 * @param {any} data
 * @returns {any}
 */
var scoreRule = exports.scoreRule = function scoreRule(data) {
  return _api.default.request({
    url: '/matchScoreItemRule/getMatchScoringItemRule',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
/**
 * 描述 获取阶段评分规则
 * @author kkdy
 * @date 2021-12-06
 * @param {any} data
 * @returns {any}
 */
var getRules = exports.getRules = function getRules(data) {
  return _api.default.request({
    url: '/ MatchExpertAssignRules/getRules',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
/**
 * 描述 更新阅读时间
 * @author kkdy
 * @date 2021-12-06
 * @param {any} data
 * @returns {any}
 */
var updataReadTime = exports.updataReadTime = function updataReadTime(data) {
  return _api.default.request({
    url: '/matchWorksScore/updateReadingTime',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
/**
 * 描述 获取已经阅读时间
 * @author kkdy
 * @date 2021-12-06
 * @param {any} data
 * @returns {any}
 */
var getReadTimes = exports.getReadTimes = function getReadTimes(data) {
  return _api.default.request({
    url: '/matchWorksScore/getReadingTimeById',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
/**
 * 描述 tijiao
 * @author kkdy
 * @date 2021-12-06
 * @param {any} data
 * @returns {any}
 */
var updateWorksScore = exports.updateWorksScore = function updateWorksScore(data) {
  return _api.default.request({
    url: '/matchWorksScore/updateWorksScore',
    method: 'post',
    data: data
  });
};
var exitWorksStatus = exports.exitWorksStatus = function exitWorksStatus(data) {
  return _api.default.request({
    url: '/matchWorks/exitWorksStatus',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
/**
 * 描述 根据作品ID获取评语详情
 * @author kkdy
 * @date 2022-02-21
 * @param {any} data
 * @returns {any}
 */
var getCommit = exports.getCommit = function getCommit(data) {
  return _api.default.request({
    url: '/matchWorksScore/getScoreExpertListByWorksId',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};